<template>
  <div class="mini-Theme-content">
    <el-form class="form" size="small" label-position="right" label-width="130px" :rules="rules" :model="themeConfigForm"
      ref="themeForm">
      <el-form-item label="小程序主色调色值:" prop="themeColor">
        <el-input class="theme-form-input" v-model="themeConfigForm.themeColor" placeholder="请输入色值，如#ffffff"></el-input>
        <el-color-picker v-model="themeConfigForm.themeColor"></el-color-picker>
        <div class="base-hover-char tip-btn" @click="showTip">示意图</div>
      </el-form-item>
      <el-form-item label="小程序首页导航栏菜单文字色值:" prop="menuColor">
        <el-input v-model="themeConfigForm.menuColor" placeholder="请输入色值，如#ffffff"></el-input>
        <el-color-picker v-model="themeConfigForm.menuColor"></el-color-picker>
      </el-form-item>
      <el-form-item label="小程序首页导航栏菜单选中文字色值:" prop="menuFocusColor">
        <el-input v-model="themeConfigForm.menuFocusColor" placeholder="请输入色值，如#ffffff"></el-input>
        <el-color-picker v-model="themeConfigForm.menuFocusColor"></el-color-picker>
      </el-form-item>
      <el-row class="icon-row">
        <el-form-item label='"发现"icon:' prop="discoverIconActive">
          <imageUpload name="激活状态" tip="建议尺寸：48px*48px（或1:1）" v-model="themeConfigForm.discoverIconActive" />
        </el-form-item>
        <el-form-item prop="discoverIconInactive">
          <imageUpload name="置灰状态" tip="建议尺寸：48px*48px（或1:1）" v-model="themeConfigForm.discoverIconInactive" />
        </el-form-item>
      </el-row>
      <el-row class="icon-row">
        <el-form-item label='"我的"icon:' prop="myIconActive">
          <imageUpload name="激活状态" tip="建议尺寸：48px*48px（或1:1）" v-model="themeConfigForm.myIconActive" />
        </el-form-item>
        <el-form-item prop="myIconInactive">
          <imageUpload name="置灰状态" tip="建议尺寸：48px*48px（或1:1）" v-model="themeConfigForm.myIconInactive" />
        </el-form-item>
      </el-row>
    </el-form>
    <div class="form-footer">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <el-image-viewer
      v-if="showTipImg" 
      :on-close="() => { showTipImg = false; }" 
      :url-list="['https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/ding/shiyitu.jpg']" 
    />
  </div>
</template>
<script>
import imageUpload from "@/components/upload/img";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { validColor } from '@/utils/rules/validators.js'
import {getThemeConfig, updateThemeConfig } from '@/api/resourceService'

export default {
  components: { imageUpload, ElImageViewer },
  data() {
    return {
      rules: {
        themeColor: [{ required: true, validator: validColor, trigger: ["blur", "change"], }],
        menuColor: [{ required: true, validator: validColor, trigger: ["blur", "change"] }],
        menuFocusColor: [{ required: true, validator: validColor, trigger: ["blur", "change"] }],
        discoverIconActive: [{required: true, message: "请上传”发现“icon激活状态图片", trigger: "change",}],
        discoverIconInactive: [{required: true, message: "请上传”发现“icon置灰状态图片", trigger: "change",}],
        myIconActive: [{ required: true, message: "请上传”我的“icon激活状态图片", trigger: "change",}],
        myIconInactive: [{required: true, message: "请上传”我的“icon置灰状态图片", trigger: "change"}],
      },
      themeConfigForm: {
        discoverIconActive: null,
        discoverIconInactive: null,
        myIconActive: null,
        myIconInactive: null
      },
      showTipImg: false,
    };
  },
  created() {
    this.getInitThemeConfig();
  },
  methods: {
    // 获取初始化主题配置
    getInitThemeConfig() {
      getThemeConfig().then(res => {
        if (res.code != 0 || !res.data) return; 
        this.themeConfigForm = res.data;
      });
    },
    // 显示示意图
    showTip() {
      this.showTipImg = true;
    },
    // 保存
    submit() {
      this.$refs.themeForm.validate((valid) => {
        if (valid) {
          // let params = JSON.parse(JSON.stringify(this.themeConfigForm));
          updateThemeConfig({...this.themeConfigForm}).then(res => {
            if (res.code == 0) {
              this.$message.success(res.msg || '保存成功！')
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mini-Theme-content {
  padding: 40px;

  .theme-form-input {}

  /deep/ .el-input {
    width: 400px;
  }

  /deep/ .el-input--small .el-input__inner {
    width: 400px;
    height: 64px !important;
    line-height: 64px;
  }

  /deep/ .el-color-picker {
    height: 64px;

    .el-color-picker__trigger {
      width: 64px;
      height: 64px;
    }
  }

  .tip-btn {
    margin-left: 20px;
    width: 80px;
    line-height: 64px;
    text-align: center;
  }

  /deep/ .el-form-item__content {
    margin-left: 142px !important;
    display: flex;
    align-items: center;
  }

  .icon-row {
    display: flex;
    margin-bottom: 24px;
  }

  .form-footer {
    margin-top: 40px;
    margin-left: 420px;
  }
}
</style>
